var map = {
	"./ar.svg": 6212,
	"./bg.svg": 8628,
	"./cs.svg": 8779,
	"./de.svg": 9368,
	"./el.svg": 9038,
	"./en.svg": 4652,
	"./es.svg": 4153,
	"./fi.svg": 1206,
	"./fr.svg": 7277,
	"./he.svg": 9108,
	"./hi.svg": 5200,
	"./hr.svg": 555,
	"./it.svg": 18,
	"./ja.svg": 2962,
	"./ko.svg": 7719,
	"./ms.svg": 3169,
	"./nb.svg": 4677,
	"./nl.svg": 6787,
	"./pl.svg": 7925,
	"./pt.svg": 3069,
	"./ro.svg": 2556,
	"./ru.svg": 7206,
	"./sr.svg": 8890,
	"./sv.svg": 7558,
	"./th.svg": 7005,
	"./tr.svg": 7431,
	"./vi.svg": 790,
	"./zh.svg": 5851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1293;